/* src/app/app.component.scss */
.registration-navigation-loader {
  position: fixed;
  inset: 0;
  z-index: 2000000;
  display: grid;
  place-items: center;
  background: var(--ion-background-color, #fff);
}
.registration-navigation-loader ion-spinner {
  width: 42px;
  height: 42px;
  color: var(--ion-text-color);
}
ion-menu ion-content {
  --background: var(--ion-color-bgnew);
  --padding-top: 20px;
}
app-bottom-navigation {
  position: absolute;
  z-index: 1000000;
  bottom: 0;
  left: 0;
  right: 0;
}
ion-split-pane {
  --side-min-width: 70px;
}
ion-menu {
  --side-max-width: 320px;
}
ion-menu ion-content {
  --padding-start: 20px;
  height: 100%;
}
ion-menu ion-content #menu-list {
  height: 90%;
  overflow-y: auto;
  overflow-x: hidden;
}
ion-menu ion-content #menu-list-footer {
  height: 10%;
  overflow-y: hidden;
  overflow-x: hidden;
}
.submenu-container {
  height: 80%;
  overflow: auto;
  display: flex;
  flex-direction: row;
  align-content: flex-start;
}
.submenu-toggle {
  width: 100%;
}
.new-icon {
  font-size: 30px !important;
  position: absolute;
  top: 0;
  padding-inline-start: 4px;
}
@media only screen and (max-width: 1460px) {
  ion-menu {
    width: 70px !important;
  }
  ion-menu ion-content {
    --padding-start: 0;
    --padding-end: 0;
  }
  ion-menu .toggle-btn ion-button {
    opacity: 0;
    pointer-events: none;
  }
  ion-menu .menu-logo {
    margin-bottom: 0px;
    margin-top: 10px;
    margin-inline-start: 15px !important;
    width: 40px !important;
  }
  ion-menu ion-item {
    min-width: 47px !important;
    width: 80% !important;
  }
  ion-menu ion-item ion-icon {
    margin-inline: 0 !important;
  }
  ion-menu .sub-menu-list ion-item {
    width: 100% !important;
  }
  ion-menu .sub-menu-list ion-item ion-icon {
    margin-inline: 0 !important;
  }
}
@media only screen and (max-width: 915px) {
  #main-content {
    width: 100%;
  }
  .mobileMenu {
    margin-bottom: 50px;
  }
  ion-fab {
    margin-bottom: 80px;
  }
}
.menu-container-closed {
  width: 80%;
  height: 100%;
  justify-self: center;
}
.menuClosed ion-content {
  --padding-start: 0;
  --padding-end: 0;
}
.menuClosed ion-item {
  width: 100% !important;
}
.menuClosed ion-item ion-icon {
  margin-inline: 0 !important;
}
.menuClosed .sub-menu-list ion-item {
  width: 100% !important;
}
.menuClosed .sub-menu-list ion-item ion-icon {
  margin-inline: 0 !important;
}
.menuClosed .menu-logo {
  margin-top: 10px;
}
.emptySpace {
  height: 30px;
}
.toggle-btn {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.toggle-btn ion-button {
  color: var(--ion-text-color);
}
.closedButton {
  justify-content: center;
}
.hide {
  opacity: 0;
}
.menu-logo {
  margin-bottom: 0px;
  margin-inline-start: 20px;
  cursor: pointer;
}
#menu-list {
  background: transparent;
  padding-top: 0px;
}
#menu-list-footer {
  padding-top: 0px;
  background: transparent;
}
.font-size-smaller {
  font-size: 12px !important;
}
ion-menu.md ion-content {
  --padding-start: 8px;
  --padding-end: 8px;
  --padding-top: 20px;
  --padding-bottom: 20px;
}
ion-menu.md ion-list {
  padding: 20px 0;
}
ion-menu.md ion-list-header,
ion-menu.md ion-note {
  padding-left: 10px;
}
ion-menu.md ion-list#menu-list {
  border-bottom: 1px solid var(--ion-background-color-step-150, var(--ion-color-step-150, #d7d8da));
}
ion-menu.md ion-list#menu-list ion-list-header {
  font-size: 22px;
  font-weight: 600;
  min-height: 20px;
}
ion-menu.md ion-item {
  --padding-start: 12px;
  --padding-end: 12px;
  border-radius: 4px;
}
ion-menu.md ion-item.selected {
  --background: rgba(var(--ion-color-primary-rgb), 0.14);
}
ion-menu.md ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}
ion-menu.md ion-item ion-icon {
  color: #616e7e;
}
ion-menu.md ion-item ion-label {
  font-weight: 500;
}
ion-menu.ios ion-content {
  --padding-bottom: 20px;
  --background: var(--ion-background-color) !important;
}
ion-menu.ios ion-list {
  padding: 20px 0 0 0;
}
ion-menu.ios ion-note {
  line-height: 24px;
}
ion-menu.ios ion-item {
  --padding-start: 12px;
  --padding-end: 0px;
  --min-height: 38px;
  margin-inline-end: 20px;
}
ion-menu.ios ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}
ion-menu.ios ion-item ion-icon {
  font-size: 24px;
  color: #73849a;
}
ion-note {
  display: inline-block;
  font-size: 14px;
  color: var(--ion-color-medium-shade);
}
.userAvatar {
  margin: 0px;
  --padding-start: 0px !important;
}
.userAvatar ngx-avatars {
  margin-inline-end: 14px;
}
.userAvatar ::ng-deep ngx-avatars .avatar-content {
  font-weight: bold !important;
}
.userAvatar .actions-count {
  position: absolute;
  top: 1px;
  left: 21px;
  --padding-start: 5px;
  --padding-end: 5px;
  font-size: 10px;
}
.userAvatar .actions-count-rtl {
  position: absolute;
  top: 1px;
  right: 21px;
  --padding-start: 5px;
  --padding-end: 5px;
  font-size: 10px;
}
.avatarClosed {
  justify-content: center;
}
.avatarClosed ngx-avatars {
  margin-inline-end: 0;
}
ion-list-header {
  font-size: 24px;
  padding-inline-start: 0px !important;
  margin-top: -3px;
}
.userName {
  font-size: 24px;
  --padding-start: 0px !important;
  margin-top: -11px;
  margin-bottom: -11px;
  color: var(--ion-text-color);
  font-weight: bold;
  --background: transparent !important;
}
.showActionsBtn {
  cursor: pointer;
  font-size: 10px !important;
  margin-inline-start: 9px;
}
ion-item {
  color: rgba(var(--ion-text-color-rgb), 0.5);
  --background: transparent;
  --color-hover: var(--ion-color-primary);
  --border-radius: 40px;
  margin-bottom: 20px;
  font-size: 14px;
}
ion-item:hover ion-icon {
  color: var(--ion-color-primary);
}
ion-item.selected,
.sub-menu-parent-item > ion-item.selected {
  --color: red;
  --background: var(--ion-color-bgnew) !important;
  --border-radius: 5px;
}
ion-item.selected ion-icon,
.sub-menu-parent-item > ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}
ion-item.selected ion-label,
.sub-menu-parent-item > ion-item.selected ion-label {
  color: var(--ion-text-color);
}
.logoutBtn:hover {
  cursor: pointer;
  color: var(--ion-color-primary);
}
ion-menu.ios .sub-menu-list {
  padding: 0px;
  margin-inline-end: 10px;
  padding-inline-start: 5px;
  border-radius: 10px;
}
ion-menu.ios .sub-menu-list ion-item {
  margin-inline-end: 5px !important;
  margin-bottom: 0px !important;
}
.sub-menu-list-closed {
  padding-inline-start: 0 !important;
}
.sub-menu-list-open {
  margin-bottom: 20px;
}
.sub-menu-parent-item:hover {
  color: var(--ion-color-primary);
  cursor: pointer;
}
.active-parent ion-icon {
  color: var(--ion-color-primary) !important;
}
.active-parent ion-label {
  color: var(--ion-text-color);
}
.name-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
}
.name-row div {
  margin-right: 30px;
}
.accountActionsList {
  background: transparent;
  padding: 0px !important;
  border-bottom: 1px solid rgba(var(--ion-text-color-rgb), 0.05);
  border-top: 1px solid rgba(var(--ion-text-color-rgb), 0.05);
  width: max-content;
  margin-bottom: 20px;
  padding-bottom: 10px !important;
}
.accountActionsList ion-item {
  margin: 0px;
  background: transparent;
  font-size: 12px;
  height: 30px;
  --padding-start: 0px !important;
  opacity: 0.25;
}
.accountActionsList ion-item ion-icon {
  font-size: 15px !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin-inline-end: 12px;
}
.accountActionsList ion-item ion-label {
  margin-top: 0px;
  margin-bottom: 0px;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 150%;
  color: var(--ion-text-color);
}
.accountActionsList ion-item.actionFinished {
  opacity: 1;
}
.accountActionsList ion-item.actionFinished ion-label {
  color: var(--ion-color-success);
  font-weight: 500;
}
.accountActionsList ion-item.nextAction {
  opacity: 1;
}
.accountActionsList ion-item.nextAction ion-label {
  font-weight: 500;
}
.accountStatus {
  color: var(--ion-text-color);
  margin-bottom: 15px;
  margin-top: 10px;
}
.accountStatus ion-chip.chipVerified {
  --background: var(--ion-color-success);
  --color: var(--ion-color-light);
}
.accountStatus ion-chip.chipPending {
  --background: var(--ion-color-warning);
  --color: var(--ion-color-light);
}
@media screen and (max-height: 800px) {
  .emptySpace {
    height: 0px;
  }
  .menu-logo {
    margin-bottom: 0px;
    margin-top: 10px;
  }
  ion-item {
    margin-bottom: 10px;
  }
}
.cardVerifyEmail {
  position: absolute;
  left: 33%;
  top: 24%;
  width: 430px;
  height: 441px;
  border-radius: 5px;
  z-index: 3;
}
@media only screen and (max-width: 480px) {
  .cardVerifyEmail {
    position: absolute;
    left: -4%;
    top: 24%;
    width: 386px;
    height: 441px;
    border-radius: 5px;
    z-index: 3;
  }
}
@media (min-width: 481px) and (max-width: 915px) {
  .cardVerifyEmail {
    position: absolute;
    left: 21%;
    top: 24%;
    width: 430px;
    height: 441px;
    border-radius: 5px;
    z-index: 3;
  }
}
.iconVerifyEmail {
  cursor: pointer;
  zoom: 2;
  position: absolute;
  right: 3%;
  top: 2%;
}
.labelVerifyEmail {
  position: absolute;
  width: 358px;
  height: 45px;
  left: calc(50% - 102px);
  top: 60%;
  font-family: var(--ion-font-family);
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: -0.02em;
}
.buttonVerifyEmail {
  width: 200px;
  height: 45px;
  position: absolute;
  left: 25%;
  right: 0%;
  top: 80%;
  bottom: 0%;
  background: var(--ion-color-primary);
  border-radius: 5px;
}
.overlay {
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  cursor: pointer;
}
.imgVerifyEmail {
  position: absolute;
  width: 204px;
  height: 159px;
  left: calc(50% - 102px);
  top: calc(50% - 79.5px - 79.5px);
}
.submenu-side-left {
  position: absolute;
  top: 0px;
  bottom: 0;
  left: 0;
  z-index: 90;
  background: var(--ion-background-color);
  width: 250px;
  padding-top: 20px;
  padding-inline-start: 5px;
  padding-inline-end: 5px;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.15);
}
.submenu-side-left .title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline-start: 20px;
}
.submenu-side-left .title-container ion-label {
  font-size: 18px;
  font-weight: 400;
  font-family: var(--ion-font-family);
  color: var(--ion-text-color);
}
.submenu-side-left .title-container ion-button {
  color: var(--ion-text-color);
  opacity: 0.5;
}
.submenu-side-right {
  position: absolute;
  top: 0px;
  bottom: 0;
  right: 0;
  z-index: 90;
  background: var(--ion-background-color);
  width: 250px;
  padding-top: 20px;
  padding-inline-start: 5px;
  padding-inline-end: 5px;
  box-shadow: -1px 1px 4px 1px rgba(0, 0, 0, 0.15);
}
.submenu-side-right .title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline-start: 20px;
}
.submenu-side-right .title-container ion-label {
  font-size: 18px;
  font-weight: 400;
  font-family: var(--ion-font-family);
  color: var(--ion-text-color);
}
.submenu-side-right .title-container ion-button {
  color: var(--ion-text-color);
  opacity: 0.5;
}
.active-parent {
  color: var(--ion-color-primary-contrast) !important;
  background: var(--ion-color-bgnew) !important;
}
.redirect-link {
  color: unset !important;
  text-decoration: none;
  margin-bottom: 2px;
}
.redirect-link ion-item:hover {
  color: var(--ion-color-primary);
  --background: rgba(var(--ion-color-primary-rgb), 0.05);
}
.redirect-link ion-item:hover ion-icon {
  color: var(--ion-color-primary) !important;
}
ion-modal.session-timeout-modal {
  --width: 430px;
  --height: 372px;
  --max-width: calc(100vw - 32px);
  --border-radius: 4px;
  --background: var(--ion-background-color);
  --box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
ion-modal.session-timeout-modal::part(content) {
  width: var(--width);
  height: var(--height);
  max-width: var(--max-width);
  border-radius: var(--border-radius);
  background: var(--ion-background-color);
}
.session-timeout-content {
  --background: var(--ion-background-color);
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
}
.session-timeout-container {
  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
  padding: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: space-between;
}
.session-timeout-icon {
  display: block;
  width: 120px;
  height: 120px;
  flex-shrink: 0;
  margin-bottom: 24px;
}
.sessionTitle {
  margin: 0 0 24px;
  color: var(--ion-text-color);
  text-align: center;
  font-family: var(--ion-font-family);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.36px;
}
.sessionText {
  color: var(--ion-text-color);
  text-align: center;
  font-family: var(--ion-font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.28px;
  margin: 0 0 24px;
}
.session-timeout-container p strong {
  font-weight: 700;
}
.session-timeout-button {
  width: 200px;
  height: 45px;
  margin: 0;
  --background: var(--ion-color-primary);
  --background-hover: var(--ion-color-primary-shade);
  --border-radius: 5px;
  --box-shadow: none;
  font-size: 10px;
  font-weight: 500;
  text-transform: none;
}
.sessionButton {
  color: var(--ion-color-primary-contrast);
  text-align: center;
  font-family: var(--ion-font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
}
@media (max-width: 462px) {
  ion-modal.session-timeout-modal {
    --width: calc(100vw - 32px);
  }
}
/*# sourceMappingURL=app.component.css.map */
